(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atelier-booking-recovery"] && !Shopify.designMode) return;
  try {
    (() => {
  const boundDialogs = new WeakSet();
  const reportedInquiries = new Set();
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const dismiss = target?.closest('.elunora-booking-dismiss');
    if (dismiss) {
      const dialog = dismiss.closest('.elunora-booking-dialog');
      if (dialog?.open && dialog.querySelector('iframe')?.dataset.elunoraRecovery === '1') dialog.close();
      return;
    }
    const trigger = target?.closest('.elunora-booking-trigger');
    if (!trigger) return;
    const block = trigger.closest('.elunora-booking-block');
    const dialog = block?.querySelector('.elunora-booking-dialog');
    const frame = dialog?.querySelector('iframe');
    // The extension handles the click first when its own script is available.
    if (!dialog || !frame || dialog.open || !trigger.dataset.elunoraUrl) return;
    let url;
    try { url = new URL(trigger.dataset.elunoraUrl, location.origin); } catch { return; }
    if (url.protocol !== 'https:') return;
    let variants = [];
    try { variants = JSON.parse(block.querySelector('.elunora-product-variants')?.textContent || '[]'); } catch { return; }
    if (!Array.isArray(variants)) return;
    const product = block.closest('product-component') || block.closest('.shopify-section') || block;
    const candidates = [product.querySelector('input[type="radio"][data-variant-id]:checked')?.dataset.variantId, new URL(location.href).searchParams.get('variant'), product.querySelector('input[name="id"]')?.value];
    const variant = candidates.find(id => variants.some(v => String(v.id) === String(id)));
    const collection = variants.find(v => String(v.id) === String(variant))?.title || trigger.dataset.elunoraCollection;
    url.searchParams.set('embed', '1');
    url.searchParams.set('collection', collection || '');
    url.searchParams.set('parentOrigin', location.origin);
    if (variant) url.searchParams.set('variant', variant);
    if (!boundDialogs.has(dialog)) {
      boundDialogs.add(dialog);
      dialog.addEventListener('close', () => {
        frame.removeAttribute('src');
        delete frame.dataset.elunoraRecovery;
        trigger.focus();
      });
    }
    frame.dataset.elunoraRecovery = '1';
    frame.src = url.href;
    dialog.showModal();
  });
  window.addEventListener('message', event => {
    for (const frame of document.querySelectorAll('.elunora-booking-dialog iframe[data-elunora-recovery="1"]')) {
      if (!frame.getAttribute('src') || event.source !== frame.contentWindow || event.origin !== new URL(frame.src).origin) continue;
      if (event.data?.type === 'elunora:booking-close') { frame.closest('dialog').close(); return; }
      const id = event.data?.conversionId;
      if (event.data?.type !== 'elunora:inquiry-saved' || typeof id !== 'string' || !/^[a-f0-9]{64}$/.test(id) || reportedInquiries.has(id)) return;
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish !== 'function') return;
      reportedInquiries.add(id);
      try { Promise.resolve(analytics.publish('elunora:inquiry_saved', {conversion_id:id})).catch(() => reportedInquiries.delete(id)); }
      catch { reportedInquiries.delete(id); }
      return;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atelier-cart-photo-previews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atelier-cart-photos')) {
    customElements.define('atelier-cart-photos', class extends HTMLElement {
      connectedCallback() {
        const signature = this.dataset.photos + '|' + this.dataset.count;
        if (this.photoSignature === signature && this.querySelector('.atelier-cart-photos__content')) return;
        this.photoSignature = signature;
        const content = document.createElement('div');
        content.className = 'atelier-cart-photos__content';
        const heading = document.createElement('p');
        heading.textContent = this.dataset.heading;
        content.append(heading);
        const showError = () => {
          if (content.querySelector('.atelier-cart-photos__error')) return;
          const message = document.createElement('p');
          message.className = 'atelier-cart-photos__error';
          message.setAttribute('role', 'status');
          message.textContent = this.dataset.error;
          content.append(message);
        };
        try {
          const photos = JSON.parse(this.dataset.photos || 'null');
          const count = Number(this.dataset.count);
          if (![6, 12].includes(count) || !Array.isArray(photos) || photos.length !== count) throw new Error('Invalid photos');
          if (!photos.every(url => typeof url === 'string' && /^https:\/\/ucarecdn\.com\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/$/i.test(url))) throw new Error('Invalid photo URL');
          const grid = document.createElement('div');
          grid.className = 'atelier-cart-photos__grid';
          photos.forEach((url, index) => {
            const img = document.createElement('img');
            img.width = 240;
            img.height = 240;
            img.alt = this.dataset.alt + ' ' + (index + 1);
            img.loading = 'lazy';
            img.referrerPolicy = 'no-referrer';
            img.addEventListener('error', showError, { once: true });
            img.src = url + '-/resize/240x240/';
            grid.append(img);
          });
          content.append(grid);
        } catch {
          showError();
        }
        this.replaceChildren(content);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
